import React from 'react';
import { WrappedCard } from '../WrappedCard';
import { WrappedImage } from '../WrappedImage';
import { wrappedCopy } from '../../../lib/wrapped/wrappedCopy';

interface WagersCardProps {
  totalWagers: number;
  netWagerWingo: number;
  avatarUrl?: string;
  username?: string;
}

export const WagersCard: React.FC<WagersCardProps> = ({
  totalWagers,
  netWagerWingo,
  avatarUrl,
  username,
}) => {
  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-4 md:space-y-5 relative z-10">
        {/* Daisy wager image - always show, even if no wagers */}
        <div className="flex justify-center mb-3 md:mb-4">
          <WrappedImage
            src="/daisy_wager.png"
            alt="DAISY Wager"
            className="rounded-2xl border-4 border-yellow-400 shadow-2xl"
            style={{ 
              maxWidth: '280px',
              maxHeight: '280px',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
              display: 'block'
            }}
            maxWidth="280px"
            maxHeight="280px"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />
        </div>
        
        {totalWagers === 0 ? (
          <div className="bg-black/60 backdrop-blur-md rounded-2xl p-5 md:p-6 border-2 border-yellow-400/50 shadow-2xl">
            <p className="text-base md:text-lg lg:text-xl text-yellow-200 font-bold text-center px-2">
              {wrappedCopy.cards.wagers.noWagers}
            </p>
          </div>
        ) : (
          <div className="bg-black/60 backdrop-blur-md rounded-2xl p-4 md:p-5 border-2 border-yellow-400/50 shadow-2xl">
            <p className="text-xl md:text-2xl text-yellow-200 font-bold text-center mb-3">
              {wrappedCopy.cards.wagers.wingoWorldWagers}
            </p>
            <div className="text-5xl md:text-6xl lg:text-7xl font-bold bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent mb-2 text-center break-words">
              {totalWagers.toLocaleString()}
            </div>
            <p className="text-base md:text-lg text-yellow-200 font-semibold text-center">
              Net: {netWagerWingo > 0 ? '+' : ''}
              {netWagerWingo.toFixed(1)} WINGO
            </p>
          </div>
        )}
      </div>
    </WrappedCard>
  );
};

